import {Component, Input, OnInit} from '@angular/core';
import {PrintNodeOrder} from "../../../../model/PrintNodeOrder";
import {PrintNodeOrderItem} from "../../../../model/PrintNodeOrderItem";

@Component({
  selector: 'app-print-node-order-item',
  templateUrl: './print-node-order-item.component.html',
  styleUrls: ['./print-node-order-item.component.css']
})
export class PrintNodeOrderItemComponent implements OnInit {
  @Input() printNodeOrderItem: PrintNodeOrderItem;

  constructor() { }

  ngOnInit() {
  }

}
